import { render, staticRenderFns } from "./SfTableHeading.vue?vue&type=template&id=38ab574a&"
import script from "./SfTableHeading.vue?vue&type=script&lang=js&"
export * from "./SfTableHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports